module.exports = __webpack_public_path__ + "static/img/animation1.c95ad10.png";